  <div *ngIf="this.mls.featureOnOffList.featureList.calendar.value || !mls.userLoginFlow">
  <ul
    class="evnt-lst-wrapper"
    [ngClass]="{ '': callingfrom === 'suggestionRight' }">
    <div
      infiniteScroll
      [infiniteScrollDistance]="numbers.TWO"
      [infiniteScrollThrottle]="numbers.FIFTY"
      [infiniteScrollDisabled]="busyGettingData"
      (scrolled)="onScrollDown()"
      [scrollWindow]="callingfrom === 'suggestionRight' ? false : true"
      [ngClass]="{ 'clndarList p-3'  : callingfrom === 'suggestionRight' }">
      <li class="clearfix" *ngFor="let item of eventList">
        <div class="lineseparator p-3 pr-0">
          <div class="d-inline-block bg-transparent heading-4 relative pr-3 datecontent">
            {{item.card[0].date}}
            <span class="d-block secondary-paragraph">{{item.card[0].month}}</span>
          </div>
        </div>
        <div class="clearfix">
          <div class="p-3 bg-white container-shadow mb-3" *ngFor="let card of item.card">
            <div
              class="cursor-pointer"
              (click)="navigateToEventDetail(card.cardData)">
              <div class="mb-2">
              <span
                class="commn-card__type"
                *ngIf="card.cardData.eventType"
                [ngStyle]="{ color: card.cardData.eventType.fgColor }">
                <img [src]="card.cardData.eventType.iconUrl" alt="icon" />
                <span class="secondary-paragraph pl-2"><span [ngStyle]="{color:card.cardData.eventType.fgColor}">{{ card.cardData.eventType.title }}</span></span>
              </span>
              <div
                class="float-right"
                *ngIf="callingfrom !== 'suggestionRight'">
                <span
                  class="status-tgs chip small outline"
                  *ngIf="card.cardData.tags && card.cardData.productType === productTypes.meeting && !card.cardData?.joinMeeting?.isJoinMeetingEnabled"
                  [ngStyle]="{backgroundColor: card.cardData.tags.bgColor,color: card.cardData.tags.fgColor}">
                  <img
                    *ngIf="card.cardData.tags.iconUrl !== ''"
                    [src]="card.cardData.tags.iconUrl !== ''? card.cardData.tags.iconUrl: ''"
                    onerror=""
                    alt="icon"/>
                  {{ card.cardData.tags.label }}
                </span>
              </div>
              </div>
              <h3 class="heading-4 pb-1">
                <span class="pr-2">{{ card.cardData.title }}</span>
                <span class="float-right res-arrow">
                <img width="16" height="16px" src="assets/themes/icons/right-arrow.svg" alt="arrow" />
                </span>
              </h3>
              <span
                class="d-block primary-small"
                *ngIf="card.cardData.productType === productTypes.meeting && card.cardData.rescheduleTimeSlots.length !== 0"> 
               <span class="color-grey-700 pb-2">
                {{ mls.languageText.event_card_data.key10 }}</span>
              </span>
              <span class="secondary-paragraph pb-2">
                <span class="color-grey-700" *ngIf="card.cardData.productType === productTypes.event">
                  {{card.cardData.timeSlots[0].startTime| dateTimezone : card.cardData.timeSlots[0].timeZone| date : "dd MMM yyyy, h:mm a"}}
                  -{{card.cardData.timeSlots[0].endTime| dateTimezone : card.cardData.timeSlots[0].timeZone| date : "dd MMM yyyy, h:mm a"}}
                </span>
                <span class="color-grey-700"
                  *ngIf="card.cardData.productType === productTypes.meeting">
                  {{card.cardData.timeSlots[0].startTime| dateTimezone : localTimeZone| date : "dd MMM yyyy, h:mm a"}}
                  -{{card.cardData.timeSlots[0].endTime| dateTimezone : localTimeZone| date : "dd MMM yyyy, h:mm a"}}| {{ timeZoneText(localTimeZone) }}
                </span>
                <span class="color-grey-700"
                  *ngIf="card.cardData.productType === productTypes.webinar">
                  {{card.cardData.timeSlots[0].startTime| dateTimezone : card.cardData.timeSlots[0].timeZone| date : "dd MMM yyyy, h:mm a"}}
                </span>
                <span class="color-grey-700"
                  *ngIf="card.cardData.productType !== productTypes.meeting">
                  | {{ card.cardData.timeSlots[0].timeZone }}
                </span>
              </span>
              <div  
              *ngIf="card.cardData.productType === productTypes.meeting && card.cardData.rescheduleTimeSlots !== null && card.cardData.rescheduleTimeSlots.length !== 0">
                <span
                  class="d-block"
                  *ngIf="card.cardData.rescheduleTimeSlots.length === 1">
                <span class="primary-small pb-2">
                <span class="color-grey-700">
                  {{ mls.languageText.event_card_data.key11 }}</span></span>
                </span>
                <div
                  *ngFor="let time of card.cardData.rescheduleTimeSlots;let i = index">
                  <span
                    class="d-block"
                    *ngIf="card.cardData.rescheduleTimeSlots.length > 1">
                  <span class="color-grey-500 pb-2">
                    {{ mls.languageText.event_card_data.key11 }} {{ i + 1 }}</span>
                  </span>
                  <span class="secondary-paragraph pb-2">
                    <span class="color-grey-700">
                      {{time.startTime| dateTimezone : localTimeZone| date : "dd MMM yyyy, h:mm a"}}
                      -{{time.endTime| dateTimezone : localTimeZone| date : "dd MMM yyyy, h:mm a"}}| {{ timeZoneText(localTimeZone) }}
                    </span>
                  </span>
                </div>
              </div>
              <div
                class="my-3 avatar horizontal-grp d-flex align-items-center"
                *ngIf="card.cardData.participants">
                <span
                  class="icon flex-shrink-0"
                  *ngFor="let member of card.cardData.participants;let i = index">
                  <span *ngIf="i < 10">
                    <img width="24px"
                      [src]="member.role === 'mr'? member.data.profilePic !== ''? member.data.profilePic: 'assets/themes/icons/user-profile-placeholder.svg': member.data.profile_pic !== ''? member.data.profile_pic: 'assets/themes/icons/user-profile-placeholder.svg'"
                      onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'"
                      alt="DP icon"/>
                    
                    <span *ngIf="member.data.profile_pic === ''">
                      {{ member.data.full_name.charAt(0) | uppercase }}
                    </span>
                    <span *ngIf="member.data.profilePic === ''">
                      {{ member.data.name.charAt(0) | uppercase }}
                    </span>
                    
                    <span *ngIf="i === 2">
                      +{{ card.cardData.participants.length - 2 }}
                    </span>
                  </span>
                </span>
                <div class="ml-2">
                  <span
                    class="secondary-paragraph"
                    *ngFor="let member of card.cardData.participants;let i = index">
                    <span *ngIf="i < 2">
                      <span class="color-grey-700">
                        {{member.role === "mr"? member.data.name: member.data.full_name}}
                      </span>
                      <span *ngIf="i < 1 && card.cardData.participants.length !== 1">,</span>
                    </span>
                    <span *ngIf="i === 2">
                      <span class="color-grey-700 font-weight-bold">+{{ card.cardData.participants.length - 2 }}
                      {{card.cardData.participants.length - 2 === 1? "Other": "Others"}}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div
              *ngIf="(callingfrom !== 'suggestionRight' && card.cardData.productType === productTypes.meeting &&
              card.cardData.conferenceStatus.status !==meetingStatus.meetingExpired &&
              card.cardData.conferenceStatus.status !==meetingStatus.meetingEnded) || card.cardData?.joinMeeting?.isJoinMeetingEnabled" 
              class="my-1 text-right">
              <button
                class="btn-design small outline"
                (click)="eventAction({type: 'decline',viewModal: true,meeting: card.cardData})"
                *ngIf="card.cardData.userStatus === userStatus.pending">
                {{ mls.languageText.event_card_data.key4 }}
              </button>
              <button
                class="ml-3 btn-design small outline"
                (click)="eventAction({type: 'reschedule',viewModal: true,meeting: card.cardData})"
                *ngIf="card.cardData.userStatus === userStatus.pending">
                {{ mls.languageText.event_card_data.key5 }}
              </button>
              <button
                class="ml-3 btn-design small filled"
                (click)="card.cardData.rescheduleTimeSlots.length > 1? eventAction({type: 'accept-from-list',viewModal: true,meeting: card.cardData}): acceptMeeting(card.cardData)"
                *ngIf="card.cardData.userStatus === userStatus.pending">
                <img
                  width="15"
                  src="assets/themes/icons/checkmark-white.svg"
                  alt="icon"/>
                {{ mls.languageText.event_card_data.key6 }}
              </button>
              <button
                class="ml-3 btn-design small filled"
                (click)="joinMeeting(card.cardData)"
                
                *ngIf="(card.cardData.eventType.typeId === meetingType.online &&
                    card.cardData.productType === productTypes.meeting &&
                    card.cardData.userStatus === userStatus.accepted &&
                    card.cardData.conferenceStatus.status !==meetingStatus.meetingExpired && 
                    card.cardData.conferenceStatus.status !==meetingStatus.meetingEnded) ||
                    card.cardData?.joinMeeting?.isJoinMeetingEnabled">
                {{ mls.languageText.event_card_data.key8 }}
              </button>
            </div>
            <div
              *ngIf="callingfrom !== 'suggestionRight' && card.cardData.productType === productTypes.webinar &&false"
              class=" text-right">
              <button
                class="btn-design small filled"
                *ngIf="card.cardData.timeSlots[0].startTime - 10 * 60 * 1000 <=currentTime && card.cardData.productType === productTypes.webinar">
                {{ mls.languageText.event_card_data.key9 }}
              </button>
            </div>
          </div>
        </div>
      </li>
      <li *ngIf="!loadList && eventList.length === 0">
        <div
          class="text-center px-3 no-data-bx"
          [ngClass]="{ gndround: callingfrom === 'suggestionRight' }">
          <img [src]="noDataImage" alt="icon" />
          <h5 class="heading-4"><span class="color-grey-500">{{ noDataText }}</span></h5>
          <p><span class="color-grey-500">{{ noDataDescText }}</span></p>
        </div>
      </li>
      <li *ngIf="loadList">
        <div class="text-center p-3">Loading...</div>
      </li>
    </div>
  </ul>
  <app-web-calendar-actions  
    (meetingData)="updateMeeting($event)"
    (closeModalData)="actionOnModal($event)"
    [actionModalActive]="actionModalActive"
    [meeting]="meeting"
    [rescheduleMeetingData]="rescheduleMeetingData"
    [modalType]="modalType">
  </app-web-calendar-actions>
</div>